import http from 'axios';

export default {

  courseExists(name, category, language) {
    return http.get(`courses?filter={"where":{"name":"${name}","category":"${category}","language":"${language}"}}`)
        .then(({data}) => {
          return (data.length > 0)
        })
        .catch(err => {
          console.error(err)
          return false
        })
    }
}
